<template>
    <v-dialog
      :model-value="dialog"
      scrollable
      persistent 
      width="800">
      <v-card>
        <v-card-title
          primary-title
        >
          {{ subClassification.name }}
        </v-card-title>

        <v-divider></v-divider>

        <v-card-text>
          <v-container 
            fluid>
            <v-autocomplete
              v-model="userSkills"
              :items="skillSelection.availableSkills"
              item-title="name"
              item-value="skillId"
              :label="$t(`profil.${this.lang}.section_my_skills`)"
              chips
              multiple
            >
            </v-autocomplete>
          </v-container>

          <v-container  v-for="item in ratedSkills"
            :key="item.id"
            fluid >
            <v-toolbar
              flat>
              <v-btn
                color="red" 
                @click="updateSkill(item.skillId, 0)"
                icon>
                <v-icon>mdi-close-circle-outline</v-icon>
              </v-btn>
              <v-toolbar-title>{{item.name}}</v-toolbar-title>
              <v-spacer/>
              <v-tooltip
                  top
                  max-width="500"
                  open-delay="1000">
                <template v-slot:activator="{ props }">
                  <div v-bind="props">
                    <v-rating
                      background-color="blue"
                      color="primary"
                      dense
                      full-icon="mdi-checkbox-blank"
                      empty-icon="mdi-checkbox-blank-outline"
                      v-model="item.level"
                      :length="item.rating.skale"
                      size="25">
                    </v-rating>
                  </div>
                </template>
                <div>
                  <div
                    v-for="(element, key) in item.rating.allowedValues "
                    :key="element">
                    <span>{{ key + ": "}}</span>
                    <span>{{ element }}</span>
                  </div>
                </div>
              </v-tooltip>
            </v-toolbar>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="error"
            
            @click="closeDialog()">
            {{$t(`profil.${this.lang}.cancel`)}}
          </v-btn>
          <v-btn
            color="primary"
            
            @click="saveSkills()">
            {{$t(`profil.${this.lang}.save`)}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
  import {mapState, mapActions} from 'vuex'

  export default {
    props: {
      dialog: Boolean,
      subClassification: Object
    },
    data () {
      return {
        deselectedSkills: [],
      }
    },
    computed: {
      ...mapState({
        basicData: state => state.users.myUser,
        skillSelection: state => state.users.skillSelection,
        lang: state => state.general.profilLang,
      }),
      userSkills: {
        get: function () {
          return (this.skillSelection.availableSkills != null) ? this.skillSelection.availableSkills.filter(skill => skill.level > 0).map(skill => skill.skillId) : null;
        },
        set: function (val) {
          if (this.skillSelection.availableSkills != null) {
            var selection = this.skillSelection.availableSkills.filter(skill => skill.level > 0).map(skill => skill.skillId);
            if (val.length > selection.length) { //add skill
              var skillId = val.filter(id => selection.indexOf(id) == -1)[0];
              this.updateSkill(skillId, 1);
            }
            else { //remove skill
              var skillId = selection.filter(id => val.indexOf(id) == -1)[0];
              this.updateSkill(skillId, 0);
            }
          }
        }
      },
      ratedSkills() {
        return (this.skillSelection.availableSkills != null) ? this.skillSelection.availableSkills.filter(skill => skill.level > 0) : [];
      }
    },
    created() {
      this.getAvailableSkills({
        userID: this.basicData.userID,
        classificationID: this.subClassification.id,
        code: this.$i18n.locale
      });
    },
    methods: {
      ...mapActions('users', ['saveMySkills', 'getAvailableSkills']),
      closeDialog() {
        this.$emit("update-expandSkills", !this.dialog);
      },
      updateSkill(id, level) {
        for (let skill of this.skillSelection.availableSkills) {
          if (skill.skillId == id) {
            skill.level = level;
            if (level == 0) this.deselectedSkills.push(skill);
            else {
              var idx = this.deselectedSkills.indexOf(skill);
              if (idx != -1) this.deselectedSkills.splice(idx, 1);
            }
            break;
          }
        };
      },
      saveSkills() {
        this.saveMySkills({newMySkills: this.ratedSkills, deleteMySkills: this.deselectedSkills});
        this.$emit("update-expandSkills", !this.dialog);
      }
    }
  }
</script>
